import { CloseOutlined } from "@mui/icons-material";
import {
  type ModalProps,
  type SxProps,
  Modal,
  Box,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";

import { baseModalStyles } from "./styles";

type BaseModalProps = Omit<ModalProps, "onClose" | "sx"> & {
  title?: string;
  onClose?: () => void;
  sx?: SxProps;
};

export const BaseModal = ({
  title,
  children,
  onClose,
  sx,
  ...props
}: BaseModalProps) => (
  <Modal onClose={onClose} {...props}>
    <Box
      sx={[
        baseModalStyles.root,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {title && (
        <>
          <Box sx={baseModalStyles.header}>
            <Typography variant="h6" component="h2">
              {title}
            </Typography>
          </Box>
          <Divider />
        </>
      )}
      <IconButton sx={baseModalStyles.closeButton} onClick={onClose}>
        <CloseOutlined />
      </IconButton>
      <Box sx={baseModalStyles.content}>{children}</Box>
    </Box>
  </Modal>
);
